/*
 * @Author: ldx
 * @Date: 2022-05-10 10:38:58
 * @LastEditors: ldx
 * @LastEditTime: 2024-10-30 09:17:14
 * @Description:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'protocolDashboard',
    component: () => import('../views/ProtocolDashboard.vue')
  },
  {
    path: '/agreement',
    name: 'agreement', // 谢春使用
    component: () => import('../views/protocols/Agreement.vue')
  },
  {
    path: '/protocol', // 协议
    name: 'protocol',
    component: () => import('../views/protocols/index.vue'),
    redirect: '/protocol/teachingAide',
    children: [
      {
        path: 'teachingAide', // 授课助手-免责声明
        name: 'teachingAide',
        component: () => import('../views/protocols/teachingAide/disclaimer.vue')
      },
      {
        path: 'userAgreement', // 授课助手-用户协议
        name: 'userAgreement',
        component: () => import('../views/protocols/teachingAide/userAgreement.vue')
      },
      {
        path: 'privacyAgreement', // 授课助手-用户隐私协议
        name: 'privacyAgreement',
        component: () => import('../views/protocols/teachingAide/privacyAgreement.vue')
      },
      {
        path: 'whiteBoardDisclaimer', // 白板2软件-免责声明
        name: 'whiteBoardDisclaimer',
        component: () => import('../views/protocols/whiteBoard/disclaimer.vue')
      },
      {
        path: 'whiteBoardUserAgreement', // 白板2软件-用户协议
        name: 'whiteBoardUserAgreement',
        component: () => import('../views/protocols/whiteBoard/userAgreement.vue')
      },
      {
        path: 'whiteBoardPrivacyAgreement', // 白板2软件-用户隐私协议
        name: 'whiteBoardPrivacyAgreement',
        component: () => import('../views/protocols/whiteBoard/privacyAgreement.vue')
      },
      {
        path: 'amdoxSystemUserAgreement', // 校园综合后台-服务协议
        name: 'amdoxSystemUserAgreement',
        component: () => import('../views/protocols/AmdoxSystem/userAgreement.vue')
      },
      {
        path: 'amdoxSystemPrivacyAgreement', // 校园综合后台-统一登录隐私政策
        name: 'amdoxSystemPrivacyAgreement',
        component: () => import('../views/protocols/AmdoxSystem/privacyAgreement.vue')
      },
      {
        path: 'amdoxSystemDisclaimer', // 校园综合后台-安道帐号使用协议
        name: 'amdoxSystemDisclaimer',
        component: () => import('../views/protocols/AmdoxSystem/disclaimer.vue')
      },
      {
        path: 'controlInstallSoftware', // 校园综合后台-安道帐号使用协议
        name: 'controlInstallSoftware',
        component: () => import('../views/protocols/control/installSoftware.vue')
      },
      {
        path: 'threeClassPrivacy', // 三个课堂隐私协议
        name: 'threeClassPrivacy',
        component: () => import('../views/protocols/threeClass/privacy.vue')
      },
      {
        path: 'eduCloudPrivacy', // 门户隐私协议
        name: 'eduCloudPrivacy',
        component: () => import('../views/protocols/educloud/privacyAgreement.vue')
      },
      {
        path: 'eduCloudUserAgreement', // 门户用户服务协议
        name: 'eduCloudUserAgreement',
        component: () => import('../views/protocols/educloud/userAgreement.vue')
      },
      {
        path: 'eduCloudUserDisclaimer', // 门户免责声明
        name: 'eduCloudUserDisclaimer',
        component: () => import('../views/protocols/educloud/disclaimer.vue')
      },
      {
        path: 'eduCloudOrganizeAgreement', // 门户组织认证服务协议
        name: 'eduCloudOrganizeAgreement',
        component: () => import('../views/protocols/educloud/organizeAgreement.vue')
      },

      {
        path: 'rubikCubeDisclaimer', // 魔方-免责声明
        name: 'rubikCubeDisclaimer',
        component: () => import('../views/protocols/rubikCube/disclaimer.vue')
      },
      {
        path: 'rubikCubeUserAgreement', // 魔方-用户协议
        name: 'rubikCubeUserAgreement',
        component: () => import('../views/protocols/rubikCube/userAgreement.vue')
      },
      {
        path: 'rubikCubePrivacy', // 魔方-用户隐私
        name: 'rubikCubePrivacy',
        component: () => import('../views/protocols/rubikCube/privacy.vue')
      },
      {
        path: 'androidUserAgreement', // 安卓-用户隐私
        name: 'androidUserAgreement',
        component: () => import('../views/protocols/android/userAgreement.vue')
      },
      {
        path: 'androidPrivacyAgreement', // 安卓-隐私协议
        name: 'androidPrivacyAgreement',
        component: () => import('../views/protocols/android/privacyAgreement.vue')
      },
      {
        path: 'rubikCubeDisclaimer-2/CN', // 魔方2.0-免责声明
        name: 'rubikCubeDisclaimer-2/CN',
        component: () => import('../views/protocols/rubikCube/disclaimer2.0.vue')
      },
      {
        path: 'rubikCubeUserAgreement-2/CN', // 魔方2.0-用户协议
        name: 'rubikCubeUserAgreement-2/CN',
        component: () => import('../views/protocols/rubikCube/userAgreement2.0.vue')
      },
      {
        path: 'rubikCubePrivacy-2/CN', // 魔方2.0-用户隐私
        name: 'rubikCubePrivacy-2/CN',
        component: () => import('../views/protocols/rubikCube/privacy2.0.vue')
      },
      {
        path: 'rubikCubeUserAgreement-2/EN', // 魔方2.0-用户协议（英文）
        name: 'rubikCubeUserAgreement-2/EN',
        component: () => import('../views/protocols/rubikCube/EN/userAgreement2.0-EN.vue')
      },
      {
        path: 'rubikCubePrivacy-2/EN', // 魔方2.0-用户隐私（英文）
        name: 'rubikCubePrivacy-2/EN',
        component: () => import('../views/protocols/rubikCube/EN/privacy2.0-EN.vue')
      },
      ...(() => {
        const locales = [
          'ar-SA', // 阿拉伯语
          'bn-BD', // 孟加拉国
          'es-ES', // 西班牙语（西班牙）
          'en-US', // 英语（美国）
          'fr-FR', // 法语（法国）
          'hi-IN', // 印度
          'id-ID', // 印度尼西亚
          'ja-JP', // 日本
          'ko-KR', // 韩国
          'ms-MY', // 马来西亚
          'ru-RU', // 俄罗斯
          'th-TH', // 泰国
          'vi-VN', // 越南
          'zh-CN' // 中文（简体）
        ]
        const docs = [
          {
            name: 'Disclaimer',
            file: 'disclaimer2.0',
            comment: '魔方2.0-免责声明'
          },
          {
            name: 'UserAgreement',
            file: 'userAgreement2.0',
            comment: '魔方2.0-用户协议'
          },
          { name: 'Privacy', file: 'privacy2.0', comment: '魔方2.0-用户隐私' },
          {
            name: 'Disclaimer2.1',
            file: 'disclaimer2.1',
            comment: '魔方2.1-免责声明'
          },
          {
            name: 'UserAgreement2.1',
            file: 'userAgreement2.1',
            comment: '魔方2.1-用户协议'
          },
          { name: 'Privacy2.1', file: 'privacy2.1', comment: '魔方2.1-用户隐私' }
        ]
        const generatedRoutes = []
        for (const locale of locales) {
          for (const doc of docs) {
            generatedRoutes.push({
              path: `rubikCube${doc.name}-2/${locale}`,
              name: `rubikCube${doc.name}-2/${locale}`, // ${doc.comment}
              component: () => import(`../views/protocols/rubikCube/${locale}/${doc.file}.vue`)
            })
          }
        }
        console.log('<<< generatedRoutes >>>', generatedRoutes)

        return generatedRoutes
      })(),
      {
        path: 'rubik-cube-google-privacy/EN', // 魔方-google-用户隐私（英文）
        name: 'rubikCubeGooglePrivacyEN',
        component: () => import('../views/protocols/rubikCube/EN/googlePrivacy-2.0-EN.vue')
      },
      {
        path: 'rubik-cube-google-user-agreement/EN', // 魔方-google-用户协议（英文）
        name: 'rubikCubeGoogleUserAgreementEN',
        component: () => import('../views/protocols/rubikCube/EN/googleUserAgreement-2.0-EN.vue')
      }
    ]
  },
  {
    path: '/helpManual', // 帮助手册
    name: 'helpManual',
    component: () => import('../views/helpManuals/index.vue'),
    redirect: '/helpManual/seminar',
    children: [
      {
        path: 'seminar', // 安道研讨课堂用户帮助手册
        name: 'seminar',
        component: () => import('../views/helpManuals/seminar.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
